import { Link, useLocation } from '@tanstack/react-router';
import { Login } from '@/features/auth';
import { trackEvent } from 'vs-gs';

const Header = ({ isDirect }: { isDirect: boolean }) => {
    const isDev = import.meta.env.MODE === 'development';
    const location = useLocation();

    // 현재 경로가 메뉴 경로와 일치하는지 확인하는 함수
    const isActive = (path: string) => {
        return location.pathname.startsWith(path);
    };

    const handleGoCreate = () => {
        const deploy = import.meta.env.VITE_DEPLOY;
        if (deploy === 'prod') {
            trackEvent({
                event: '스마트 문제은행',
                parameter: '출제하기',
                parameter_value: isActive('/my-bank') ? '내 문제은행' : '출제하기',
            });
        }
    };

    return (
        <div className="ki-main-header ttukttak">
            <div className="new-header">
                {/* 히든 클래스 추가 off 25.08.27 */}
                <div className={`new-header-wrap scl utility ${isDirect ? 'off' : ''}`}>
                    <div className="utility_menu flex_b">
                        <div className="left">
                            <ul className="flex_c">
                                <li>
                                    {isDev && (
                                        <Link to="/publish" className="[&.active]:font-bold">
                                            Publish
                                        </Link>
                                    )}
                                    <a
                                        href={
                                            import.meta.env.VITE_DEPLOY === 'prod'
                                                ? 'https://e.vivasam.com'
                                                : 'https://dev2-e.vivasam.com/'
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        초등
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={
                                            import.meta.env.VITE_DEPLOY === 'prod'
                                                ? 'https://v.vivasam.com'
                                                : 'https://dev2-v.vivasam.com/'
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        중고등
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={
                                            import.meta.env.VITE_DEPLOY === 'prod'
                                                ? 'https://t.vivasam.com'
                                                : 'https://dev2-t.vivasam.com/'
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        연수원
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={
                                            import.meta.env.VITE_DEPLOY === 'prod'
                                                ? 'https://vivaclass.vivasam.com'
                                                : 'https://dev-vivaclass.vivasam.com/'
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        비바클래스
                                    </a>
                                </li>
                                <li>
                                    <div className="module_samquiz">
                                        샘퀴즈
                                        <ul>
                                            <li>
                                                <a
                                                    href={
                                                        import.meta.env.VITE_DEPLOY === 'prod'
                                                            ? 'https://samquiz.vivasam.com/main'
                                                            : 'https://dev-samquiz.vivasam.com/main'
                                                    }
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    초등
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="https://v-samquiz.vivasam.com/"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    중고등
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <Login />
                    </div>
                </div>
                {/* 히든 클래스 추가 off 25.08.27 */}
                <div className={`new-header-wrap gnb scl ${isDirect ? 'off' : ''}`}>
                    <div className="gnb_menu flex_b">
                        <div className="logo">
                            {/* <a href="/sets/created-box" rel="noreferrer"></a> */}
                            <Link to="/create" rel="noreferrer" />
                            <span className="blind">AI 스마트 평가</span>
                        </div>
                        <div className="gnbBox">
                            <div className="gnbwid">
                                <nav className="gnb">
                                    <ul>
                                        <li className={isActive('/create') ? 'on' : ''}>
                                            <Link to="/create">출제하기</Link>
                                        </li>
                                        <li
                                            className={
                                                isActive('/my-bank') ||
                                                isActive('/sets/created-box/detail') ||
                                                isActive('/sets/published-box/detail')
                                                    ? 'on'
                                                    : ''
                                            }
                                        >
                                            <Link to="/my-bank">내 문제은행</Link>
                                        </li>
                                        {/*<li className={isActive('/sets/published-box') ? 'on' : ''}>*/}
                                        {/*    <Link to="/sets/published-box">내 발행함</Link>*/}
                                        {/*</li>*/}
                                    </ul>
                                </nav>
                                <div className="btn-group">
                                    <a
                                        href="https://curse-request-cbb.notion.site/1c0992a4d84f80448ea2e47ecdc4cab6?v=1c0992a4d84f818d9c40000c0e788461"
                                        target="_blank"
                                        rel="noreferrer"
                                        // className="floatBanner"
                                    >
                                        <span>이용 가이드</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
